export const DAFAPLUS_LANGUAGE_STORAGE_KEY = 'dafaplusSelectedLanguage';

export type DafaplusLanguage = 'EN' | 'KR' | 'TH';

export interface DafaplusLanguageText {
  supportChatTitle: string;
  welcomeMessage: string;
  chatWillStartNow: string;
  closeChatTitle: string;
  closeChatConfirm: string;
  closeNo: string;
  closeYes: string;
}

export const DAFAPLUS_LANGUAGE_TEXT: Record<DafaplusLanguage, DafaplusLanguageText> = {
  EN: {
    supportChatTitle: 'DafaPlus support chat',
    welcomeMessage: 'Welcome to DafaPlus!',
    chatWillStartNow: 'Chat will start now',
    closeChatTitle: 'Close Chat',
    closeChatConfirm: 'Are you sure you want to close this chat?',
    closeNo: 'NO',
    closeYes: 'YES, CLOSE',
  },
  KR: {
    supportChatTitle: '다파플러스 고객 지원 채팅',
    welcomeMessage: '환영합니다! 다파플러스입니다',
    chatWillStartNow: '대화가 시작됩니다',
    closeChatTitle: '채팅 종료',
    closeChatConfirm: '채팅을 종료하시겠습니까?',
    closeNo: '아니오',
    closeYes: '네, 종료합니다',
  },
  TH: {
    supportChatTitle: 'แชทช่วยเหลือดาฟาพลัส',
    welcomeMessage: 'ยินดีต้อนรับสู่ดาฟาพลัส!',
    chatWillStartNow: 'เริ่มต้นการแชท',
    closeChatTitle: 'ปิดแชท',
    closeChatConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการปิดแชทนี้?',
    closeNo: 'ไม่',
    closeYes: 'ใช่, ปิดแชท',
  },
};

export const normalizeDafaplusLanguage = (languageCode?: string | null): DafaplusLanguage => {
  const normalizedCode = (languageCode || '').toUpperCase();

  if (normalizedCode === 'KR') {
    return 'KR';
  }

  if (normalizedCode === 'TH') {
    return 'TH';
  }

  return 'EN';
};

export const getDafaplusLanguageText = (languageCode?: string | null): DafaplusLanguageText => {
  return DAFAPLUS_LANGUAGE_TEXT[normalizeDafaplusLanguage(languageCode)];
};
